var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-loader"},[_c('v-icon',[_vm._v("mdi mdi-48px mdi-spin mdi-loading")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }